import React, { Component, Fragment } from 'react';
import ErrorBoundary from './../../components/ErrorBoundary';
import { instagramFormat, truncateText, returnOpacity } from './../../scripts';

export default class Caption extends Component {
  constructor(props) {
    super(props);
    this.toggleCaption = this.toggleCaption.bind(this);
    this.truncatedString = null;
    this.state = {
      description: this.props.linkData.description,
      longCaption: false
    };
    this.gradientOpacity = {
      opacity: returnOpacity(this.props.opacity)
    };
  }

  toggleCaption() {
    this.setState({
      longCaption: true,
      description: (this.state.description == this.truncatedString) ? this.props.linkData.description : this.truncatedString
    });
  }

  componentDidMount() {
    const desc = this.props.linkData.description;
    // MORE OR LESS TRUNCATE
    const descLength = desc.length;
    if (descLength > 130) {
      this.truncatedString = truncateText(desc) + '...';  ;
      truncateText(desc);
      this.setState({
        longCaption: true,
        description: this.truncatedString
      });
    };
  }

  render() {
    return (
      <Fragment>
        <ErrorBoundary>
          <div className='hp-caption-text-wrap'>
            <h3 className='hp-image-caption-primary'>
              <span dangerouslySetInnerHTML={{ __html: this.props.linkData.title }} />
            </h3>
            <h4 className='hp-image-caption-secondary'>
              <span className='hp-image-caption-secondary-span' dangerouslySetInnerHTML={{ __html: this.state.description }} />
              {(this.state.longCaption) &&
                <span onClick={() => this.toggleCaption()} className='long-caption-toggle'>
                  {(this.state.description == this.truncatedString) ?  'MORE' : 'LESS'}
                </span>
              }
            </h4>
          </div>
        </ErrorBoundary>
        {/*(this.props.type !== 'border') && <div style={this.gradientOpacity} className='hp-image-gradient'/>*/}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/Caption.js